export const VITE_POSTHOG_API_KEY: string = import.meta.env
  .VITE_POSTHOG_API_KEY;
export const POSTHOG_API_HOST: string = import.meta.env.VITE_POSTHOG_API_HOST;

export const FEATURE_FLAG_DEEPERDIVE_AB_TEST = "feature_deeperdive";
export const FEATURE_FLAG_DEEPERDIVE_AB_TEST_VARIANT =
  "test-feature_deeperdive";
